// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"de426588","144":"5312793b","196":"a89e60b2","239":"71ebb64e","455":"1d60951d","488":"9c268ece","977":"60b29528"}[chunkId] + ".chunk.js";
};